module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3r4r6n9n-ede4ee8ce44a75ea03163f6130e6147f.svg";